export default "__VITE_ASSET__BS5A2CKT__"